<template>
  <b-card border-variant="light" class="my-2">

    <b-row class="my-1">
      <b-col>
        <h5>Pirosis</h5>
      </b-col>
    </b-row>

    <b-row align-v="center" class="ml-1">
      <b-col class="col-3">
        <div>Momento del día:</div>
      </b-col>

      <b-col>
        <v-select
          placeholder="Seleccione una o mas opciones"
          :options="momentoOpts"
          :reduce="option => option"
          label="text"
          :multiple="true"
          taggable
          @input="newArray => pirosis.momento = onAddNewOpt(newArray)"
        />
      </b-col>
    </b-row>


    <b-row align-v="center" class="ml-1 my-1">
      <b-col class="col-3">
        <div>Sintomas Asociados:</div>
      </b-col>

      <b-col>
        <v-select
          placeholder="Seleccione una o mas opciones"
          :options="sintomasOpts"
          :reduce="option => option"
          label="text"
          :multiple="true"
          taggable
          @input="newArray => pirosis.sintomas = onAddNewOpt(newArray)"
        />
      </b-col>
    </b-row>

  </b-card>
</template>

<script>

import vSelect from "vue-select";
import { addNewOpt } from '@/shared/helpers';

export default {

  name: "SintomasPirosis",

  components: {
    vSelect
  },

  data() {
    return {

      pirosis:{
        momento:[],
        momentoAlimentos:'',
        sintomas:[]
      },
      momentoOpts: [
        { value: 'todo_el_dia',      text: 'Todo el dia', },
        { value: 'despues_de_comer', text: 'Despues de comer' },
        { value: 'por_la_noche',     text: 'Por la noche' },
        { value: 'por_la_madrugada', text: 'Por la madrugada' },
      ],

      sintomasOpts:[
        { value: 'dolor_de_pecho', text: 'dolor de pecho' },
        { value: 'eructos',        text: 'eructos' },
      ],

    }
  },

  methods: {
    onAddNewOpt( newValue ){
      return addNewOpt( newValue );
    }
  },

  watch: {
    pirosis: {
      deep: true,
      handler(newValue) {
        this.$store.commit("setGastro", { pirosis:newValue });
      },
    }
  }
}
</script>

<style>

</style>